import { Box, Typography } from "@mui/material";
import React, { useEffect } from "react";
import Card from "../../components/card/Card";
import { EarthImage } from "../../assets/images";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getActiveStep,
  getEnvironmentConfig,
  getNetworkSummery,
  setNetworkSummaryAi,
} from "../../redux/actions";
import { SET_ADD_NETWORK, SET_AI_DATA } from "../../redux/node/actionTypes";
import aiIcon from "../../assets/images/ai-icon.png";
import manualIcon from "../../assets/images/manual_Icon.png";
import CreateNodeButton from "./component/CreateNodeButton";

const FlexBox1Style = {
  flex: { xs: "0 0 100%", md: "0 0 49%" },
  display: { xs: "flex", md: "block" },
  justifyContent: "center",
  px: { xs: 0, sm: "1rem" },
  flexDirection: "column",
};
const MainTypoStyle = {
  // mt: { xs: "1.5rem", md: "7rem" },
  mb: "1.3rem",
  textAlign: { xs: "center", md: "left" },
  lineHeight: 1.5,
};

const FlexBox3Style = {
  flex: { xs: "0 0 100%", md: "0 0 49%" },
  marginBottom: "1.5rem",
  px: { xs: "0rem ", md: "2rem", lg: "4rem" },
  // display: { xs: "none", sm: "block" },
};

const ViewDashboard = () => {
  const Navigation = useNavigate();
  const dispatch = useDispatch();
  const { stepperSteps } = useSelector((state) => state.test);
  const handleNext = (mode) => {
    // Navigation("/network");
    Navigation(`/network?mode=${mode}`);

    dispatch(getActiveStep(0));
  };

  useEffect(() => {
    dispatch(getActiveStep(0));
    dispatch(
      getNetworkSummery({
        networkName: "",
        networkStatement: "",
      }),
    );
    let data = {
      Provider: "",
      Algorithm: "",
      accountType: "",
      value: {
        idvalue: "",
        password: "",
        period: "",
        inputFields: [],
      },
    };
    dispatch(getEnvironmentConfig(data));
    dispatch({
      type: SET_ADD_NETWORK,
      payload: null,
    });
    dispatch({
      type: SET_AI_DATA,
      payload: null,
    });

    dispatch(setNetworkSummaryAi(null));
  }, []);

  useEffect(() => {
    if (stepperSteps === -1) {
      Navigation("/");
    }
  }, [stepperSteps]);

  return (
    <React.Fragment>
      {/* Main code  starts */}
      <Card>
        <Box
          display="flex"
          alignItems="center"
          sx={{
            flexDirection: { xs: "column", lg: "row" },
            justifyContent: "space-between",
            justifyItems: "center",
          }}
        >
          {/* First flex box contain title and text */}
          <Box sx={FlexBox1Style}>
            <Box pr={2}>
              <Typography variant="h1" sx={MainTypoStyle}>
                Welcome to Chain Launch Platform
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{ textAlign: { xs: "center", md: "left" } }}
              >
                Create and launch your blockchain network with full control and
                complete asset ownership.
              </Typography>
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              gap="12px"
              marginTop="20px"
            >
              <CreateNodeButton
                onClick={() => handleNext("AI")}
                icon={aiIcon}
                title="Create node with AI"
                description="Use AI to set up your network quickly, optimized for your specific use case."
                isAIBtn={true}
              />
              <CreateNodeButton
                onClick={() => handleNext("Manual")}
                icon={manualIcon}
                title="Create node manually"
                description="Set up your network step by step with full customization."
              />
            </Box>
          </Box>
          {/* Second flex box conatin the divider line  */}
          {/* <Box sx={FlexBox2Style}>
            {" "}
            <Box sx={CardDividerStyle} />
          </Box> */}
          {/* Third Flex box code */}
          <Box sx={FlexBox3Style}>
            <Box>
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Box
                  sx={{
                    marginBottom: "1.12rem",
                    marginTop: { xs: "1.12rem", md: "5.6rem" },
                    height: {xs:'100%', sm:"336px"},
                    width: { xs: "70%", sm: "225px", md: "342px" },
                    // maxWidth: "225px",
                    // maxHeight: "221px",
                  }}
                >
                  <img
                    src={EarthImage}
                    alt="Earth connectivity"
                    style={{ height: "auto", width: "100%" }}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Card>
    </React.Fragment>
  );
};

export default ViewDashboard;
